import React from 'react';
import classNames from 'classnames';
import styles from './splash.css';
import { useTranslation } from '../hooks/translate';
import loadingAnimation from '../images/loading-animation.webp';

export const Splash = ({ skin }) => {
  const [translate] = useTranslation();

  return (
    <div className={classNames([styles.splash, styles[`splash${skin}`]])}>
      <div className={styles.loadingWrapper}>
        <span className={styles.text}>{translate('loading')}</span>
        <img className={styles.loading} src={loadingAnimation} />
      </div>
    </div>
  );
};
